// A Save button that admits it cannot save.
//
// Six reference-data detail panels and the Settings buffer sliders had a
// Save button with NO onClick. A user edited a brand-lock rule or a discount,
// pressed Save, and got no persistence and no error -- the worst outcome
// available, because it looks exactly like success.
//
// These have no backend model to write to. Rather than build endpoints for
// data nothing reads yet, the affordance is made honest: the button is
// disabled and says why, and the panel stays fully viewable.
//
// ONE component for all seven so they cannot drift into seven different
// phrasings, and so that wiring any one of them up later is a visible
// deletion of this import rather than an edit that leaves the others behind.
//
// NOT used by Settings > Company, which is a REAL save (Admin-only, writes
// through /anixify/api/save_company_settings). Do not "tidy" that one into
// this component.

import { semanticColors, heights, spacing, radius, typography } from "@/styles/tokens";

export const READ_ONLY_NOTE = "Read-only in this build";

export function ReadOnlySave({
  testId,
  label = "Save",
}: {
  /** Preserved from the button this replaces -- tests and QA depend on it. */
  testId: string;
  label?: string;
}) {
  return (
    <span className="inline-flex items-center" style={{ gap: spacing[8] }}>
      <span
        data-testid={`${testId}-readonly-note`}
        style={{
          fontSize: typography.fontSize.xs,
          color: semanticColors.textMuted,
          whiteSpace: "nowrap",
        }}
      >
        {READ_ONLY_NOTE}
      </span>
      <button
        data-testid={testId}
        type="button"
        disabled
        // The title carries the reason for anyone who hovers the control
        // itself rather than reading the note beside it.
        title={`${READ_ONLY_NOTE} — this panel does not persist changes yet.`}
        aria-disabled="true"
        style={{
          height: heights.control,
          padding: `0 ${spacing[14]}px`,
          backgroundColor: semanticColors.panelBg,
          color: semanticColors.textPlaceholder,
          border: `1px solid ${semanticColors.border}`,
          borderRadius: radius.base,
          fontSize: typography.fontSize.base,
          fontWeight: typography.fontWeight.medium,
          // Not a pointer: the cursor is the first thing that tells someone
          // this is not a live control.
          cursor: "not-allowed",
        }}
      >
        {label}
      </button>
    </span>
  );
}
